import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetFullScenarioQuery,
  GetFullScenarioQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { fullScenarioFragment } from "src/graphql/anti-fraud/fragments/FullScenarioFragment.ts";
import { useFetchQuery } from "src/graphql/utils";
import { mapToFullScenario } from "src/mappers/scenario.mappers.ts";

export const getFullScenarioQuery = gql`
  query getFullScenario($id: ID!) {
    scenario(id: $id) {
      ...FullScenarioFragment
    }
  }

  ${fullScenarioFragment}
` as TypedDocumentNode<GetFullScenarioQuery, GetFullScenarioQueryVariables>;

export const useGetFullScenarioById = (
  { id }: { id?: string },
  options?: QueryHookOptions<GetFullScenarioQuery, GetFullScenarioQueryVariables>
) => {
  return useFetchQuery(getFullScenarioQuery, {
    isEmpty: (data) => !data,
    toData: (data) => data?.scenario && mapToFullScenario(data.scenario),
    queryOptions: {
      variables: { id: id ?? "" },
      skip: !id,
      ...options,
    },
    uiErrors: {
      fetchError: "FETCH-SCENARIO-ERROR",
    },
  });
};
